import { jsx, Fragment } from "react/jsx-runtime";
import { Component } from "../coreComponents/Component.js";
const StaticRender = Component(
  () => null,
  ({ children }) => /* @__PURE__ */ jsx(Fragment, { children }),
  "StaticRender"
);
export {
  StaticRender
};
//# sourceMappingURL=StaticRender.js.map
